/** Bearbeiter-Filter pro Admin im localStorage merken (überlebt Neuladen). Eigener Schlüssel je Liste. */
const key = (list: string, adminId: number) => `sh24.${list}.assignee.${adminId}`;

export function readAssigneeFilter(list: string, adminId: number): number[] | null {
  try {
    const raw = window.localStorage.getItem(key(list, adminId));
    if (raw == null) return null;
    const v: unknown = JSON.parse(raw);
    return Array.isArray(v) && v.every(x => typeof x === 'number') ? (v as number[]) : null;
  } catch {
    return null;
  }
}

export function writeAssigneeFilter(list: string, adminId: number | null, ids: number[]): void {
  if (adminId == null) return;
  try {
    window.localStorage.setItem(key(list, adminId), JSON.stringify(ids));
  } catch { /* Speicher gesperrt: gilt nur für diese Sitzung */ }
}
